export const DC = {
  azul1: '#1F3864',
  azul2: '#2F5496',
  celeste: '#33BCE1',
  azulMuyOscuro: '#0E243E',
  azulSuave: '#D6E4F0',
  grisCl: '#F2F2F2',
  grisMed: '#D9D9D9',
  grisOsc: '#595959',
  verdeOk: '#375623',
  rojoErr: '#7B0000',
  ambar: '#856404',
} as const;
